import { render, staticRenderFns } from "./teacherAdd.vue?vue&type=template&id=68a6c058"
import script from "./teacherAdd.vue?vue&type=script&lang=js"
export * from "./teacherAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a6c058')) {
      api.createRecord('68a6c058', component.options)
    } else {
      api.reload('68a6c058', component.options)
    }
    module.hot.accept("./teacherAdd.vue?vue&type=template&id=68a6c058", function () {
      api.rerender('68a6c058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/teacherAdd.vue"
export default component.exports